import environment from "./base";
const baseApi = "https://edify-api-dev.edify.la";
const env = environment(baseApi, baseApi);
const localConfig = {
  ...env,
  intervals: {
    ...env.intervals,
    logout: 600, 
  },
  isProduction: false,
  isDevelopment: true,
  env: "local",
  SENTRY_DSN: "",
  googleMaps: {
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  },
  googleOAuth: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  },
  mercadoPago: {
    publicKey: "TEST-29c2c6a6-8092-447a-8b33-803930bb6fa6",
    clientId: "8639587373625884", 
    redirectUri: "https://unsavoury-monandrous-sandy.ngrok-free.dev/documentacion-de-obra/oauth-callback",
  },
  firebase: {
    apiKey: "AIzaSyC1837T9gKotAG9D0KLGtvA40yo2Pi1MOo",
    authDomain: "edify-firebase-test.firebaseapp.com",
    projectId: "edify-firebase-test",
    storageBucket: "edify-firebase-test.firebasestorage.app",
    messagingSenderId: "394112989092",
    appId: "1:394112989092:web:8468625ba729211cab7331",
    measurementId: "G-5T3CE63QM9",
  },
};

export default localConfig;
